import { useEffect, useState } from 'react';
import { Modal } from 'components/Modal';
import { UserPhoto } from 'components/UserPhoto';
import { SnackbarProps } from 'components/Snackbar';
import { DynamicForm } from '../../components/DynamicForm';
import { SimpleItem, CustomerProfile, ReportReasonOptions } from 'types';
import { getReportReasons, postCustomerData } from 'api';

import styles from './UserProfile.module.scss';

export type ReportModalProps = {
  reportReasons: Array<SimpleItem>;
  type?: ReportReasonOptions;
  profile: CustomerProfile | { full_name: string, username: string, photo?: string | null};
  onClose: () => void;
  onSetSnackbarMessage?: (message: SnackbarProps) => void;
};

export const ReportModal = ({
  reportReasons,
  type,
  profile,
  onClose,
  onSetSnackbarMessage = () => {},
}: ReportModalProps) => {
  const [isSubmitProcess, setIsSubmitProcess] = useState<boolean>(false);
  const [reasons, setReasons] = useState<Array<SimpleItem>>(reportReasons)

  useEffect(() => {
    if(type)
      getReportReasons(type)
        .then((response) => {
          if(response.ok && response.data)
            setReasons(response.data)
        })
  }, [])

  const handleSendReport = async (data: any) => {
    if (isSubmitProcess) {
      return;
    }

    setIsSubmitProcess(true);

    const response = await postCustomerData(profile.username, 'report', data);

    if (response.ok) {
      onSetSnackbarMessage({
        header: 'Report sent successfully',
      });
      onClose();
    } else {
      onSetSnackbarMessage({
        mode: 'error',
        header: response.message || 'Sorry, server responds with error. Please, try later',
      });
      setIsSubmitProcess(false);
    }
  };

  const reportFieldProps = [
    {
      options: reasons,
      fieldName: 'reason_id',
      mode: 'radioCheck',
      type: 'radioBox',
    },
  ];

  return (
    <Modal
      title="Report User"
      withCrossIcon
      onCoverClick={onClose}
      child={(
        <div className={styles.reportModal}>
          <div className={styles.reportModalUser}>
            <div className={styles.reportModalUserPhoto}>
              <UserPhoto src={profile.photo || ''} alt={profile.username} layout="fill" objectFit="cover" />
            </div>
            <div className={styles.reportModalUserData}>
              <div className={styles.reportModalUserName}>
                {profile.full_name}
              </div>
              <div className={styles.reportModalUserUsermame}>
                @{profile.username}
              </div>
            </div>
          </div>
          <DynamicForm
            fields={reportFieldProps}
            onSend={handleSendReport}
            onCancel={() => onClose()}
            buttonsShape="slim"
            buttonCaption="Send Report"
          />
        </div>
      )}
    />
  );
};
